module.exports = __webpack_public_path__ + "static/media/6COPUOS3.35d13d0b.jpg";